module.exports = __webpack_public_path__ + "static/media/info.a45b11e0.png";